import { writable } from 'svelte/store';
import project from '@app/external/cc-lib/dist/classes/project.js';
export const projectState = writable(new project());